// extracted by mini-css-extract-plugin
module.exports = {"Container":"Shell_Container__K3-NJ","ContainerChildren":"Shell_ContainerChildren__1ilXU"};